import { updateComponent } from '../../../redux/editorSlice';

// 이미지 컴포넌트 내용 변경 핸들러
export const handleImageChange = (selectedComponent, field, value, dispatch) => {
  if (!selectedComponent) return;
  
  const existingContent = typeof selectedComponent.content === 'object' && selectedComponent.content !== null
    ? JSON.parse(JSON.stringify(selectedComponent.content))
    : { src: '', alt: '' };
    
  // 필드 업데이트
  existingContent[field] = value;
  
  // 컴포넌트 업데이트
  dispatch(updateComponent({
    id: selectedComponent.id,
    changes: {
      content: existingContent
    }
  }));
};

// 데이터 변경 핸들러 (게시판, 상세 페이지 등 복잡한 컴포넌트용)
export const handleDataChange = (selectedComponent, field, value, devicePropertyTab, dispatch) => {
  if (!selectedComponent) return;
  
  // 디바이스 속성 탭이 선택된 경우, 해당 디바이스에 대한 데이터만 변경
  if (devicePropertyTab) {
    // 깊은 복사를 위해 JSON.parse(JSON.stringify()) 사용
    const existingData = selectedComponent.data 
      ? JSON.parse(JSON.stringify(selectedComponent.data)) 
      : {};
    
    // 디바이스별 객체 초기화
    if (!existingData.deviceProperty) {
      existingData.deviceProperty = {
        pc: {},
        mobile: {}
      };
      
      // 기존 속성을 PC/모바일에 복사 (deviceProperty 제외)
      Object.keys(existingData).forEach(key => {
        if (key !== 'deviceProperty' && key !== 'device') {
          existingData.deviceProperty.pc[key] = existingData[key];
          existingData.deviceProperty.mobile[key] = existingData[key];
        }
      });
    }
    
    // 선택된 디바이스 탭에 속성 업데이트
    if (!existingData.deviceProperty[devicePropertyTab]) {
      existingData.deviceProperty[devicePropertyTab] = {};
    }
    
    existingData.deviceProperty[devicePropertyTab][field] = value;
    
    // PC 모드일 때만 최상위 속성에도 적용
    if (devicePropertyTab === 'pc') {
      existingData[field] = value;
    }
    
    dispatch(updateComponent({
      id: selectedComponent.id,
      changes: {
        data: existingData
      }
    }));
  } else {
    // 깊은 복사 수행
    const existingData = selectedComponent.data 
      ? JSON.parse(JSON.stringify(selectedComponent.data)) 
      : {};
    
    // 최상위 속성 업데이트
    existingData[field] = value;
    
    // 디바이스별 속성도 업데이트
    try {
      if (existingData.deviceProperty) {
        if (existingData.deviceProperty.pc) {
          existingData.deviceProperty.pc[field] = value;
        }
        if (existingData.deviceProperty.mobile) {
          existingData.deviceProperty.mobile[field] = value;
        }
      }
    } catch (error) {
      console.error('디바이스별 속성 업데이트 오류:', error);
    }
    
    dispatch(updateComponent({
      id: selectedComponent.id,
      changes: {
        data: existingData
      }
    }));
  }
};

// 일반 콘텐츠 변경 핸들러 (디바이스별 속성 지원)
export const handleContentChange = (selectedComponent, value, devicePropertyTab, dispatch) => {
  if (!selectedComponent) return;
  
  // 디바이스 속성 탭이 선택된 경우, 해당 디바이스에 대한 컨텐츠만 변경
  if (devicePropertyTab) {
    // 깊은 복사를 위해 JSON.parse(JSON.stringify()) 사용
    const existingContent = selectedComponent.content
      ? JSON.parse(JSON.stringify(selectedComponent.content))
      : {};

    const isObject = typeof existingContent === 'object' && existingContent !== null;

    if (isObject) {
      // 객체 타입의 content인 경우
      // 디바이스별 객체 초기화
      if (!existingContent.deviceProperty) {
        existingContent.deviceProperty = {
          pc: {},
          mobile: {}
        };

        // 기존 속성을 PC/모바일에 복사 (deviceProperty 제외)
        Object.keys(existingContent).forEach(key => {
          if (key !== 'deviceProperty') {
            existingContent.deviceProperty.pc[key] = existingContent[key];
            existingContent.deviceProperty.mobile[key] = existingContent[key];
          }
        });
      }

      // 선택된 디바이스 탭에 속성 업데이트
      if (!existingContent.deviceProperty[devicePropertyTab]) {
        existingContent.deviceProperty[devicePropertyTab] = {};
      }

      // 객체가 아닌 경우 문자열로 처리
      if (typeof value !== 'object') {
        existingContent.deviceProperty[devicePropertyTab] = value;
      } else {
        // 객체인 경우 각 속성을 복사
        existingContent.deviceProperty[devicePropertyTab] = { ...value };
      }

      // PC 모드일 때만 최상위 content도 업데이트
      if (devicePropertyTab === 'pc') {
        // 문자열이면 직접 할당
        if (typeof value !== 'object') {
          existingContent.value = value;
        }
        // 객체이면 각 속성 복사
        else if (value !== null) {
          Object.keys(value).forEach(key => {
            if (key !== 'deviceProperty') {
              existingContent[key] = value[key];
            }
          });
        }
      }

      dispatch(updateComponent({
        id: selectedComponent.id,
        changes: {
          content: existingContent
        }
      }));
    } else {
      // 기본 타입의 content인 경우 (문자열 등)
      const newContent = {
        value: existingContent, // 기존 값을 value 속성으로 저장
        deviceProperty: {
          pc: existingContent,
          mobile: existingContent
        }
      };

      // 선택된 디바이스 탭에 속성 업데이트
      newContent.deviceProperty[devicePropertyTab] = value;

      // PC 모드일 때만 최상위 값도 업데이트
      if (devicePropertyTab === 'pc') {
        newContent.value = value;
      }

      dispatch(updateComponent({
        id: selectedComponent.id,
        changes: {
          content: newContent
        }
      }));
    }
  } else {
    // 디바이스 속성 탭이 선택되지 않은 경우 모든 디바이스에 적용
    if (
      typeof selectedComponent.content === 'object' &&
      selectedComponent.content !== null &&
      selectedComponent.content.deviceProperty
    ) {
      // 깊은 복사
      const newContent = JSON.parse(JSON.stringify(selectedComponent.content));

      // 최상위 값 업데이트
      if (typeof value === 'object' && value !== null) {
        Object.keys(value).forEach(key => {
          if (key !== 'deviceProperty') {
            newContent[key] = value[key];
          }
        });
      } else {
        newContent.value = value;
      }

      // 디바이스별 값도 업데이트
      try {
        if (newContent.deviceProperty.pc !== undefined) {
          newContent.deviceProperty.pc = typeof value === 'object' ? { ...value } : value;
        }
        if (newContent.deviceProperty.mobile !== undefined) {
          newContent.deviceProperty.mobile = typeof value === 'object' ? { ...value } : value;
        }
      } catch (error) {
        console.error('디바이스별 속성 업데이트 오류:', error);
      }

      dispatch(updateComponent({
        id: selectedComponent.id,
        changes: {
          content: newContent
        }
      }));
    } else {
      // 단순 값인 경우 그대로 업데이트
      dispatch(updateComponent({
        id: selectedComponent.id,
        changes: {
          content: value
        }
      }));
    }
  }
}; 